<div class="ev-button primary itinerary-dropdown" data-testid="itinerary-toggle-btn" (click)="toggle()" [class.active]="itineraryDropdown()"
  [hidden]="loadingMap || noRoute">
  <div class="itinerary-text">
    {{ languageService.languageJSON.InfoSidebar_Tooltip_Itinerary }}
  </div>
  <span class="itinerary-icon" aria-hidden="true"></span>
</div>
@if (itineraryDropdown()) {
<div class="itinerary" data-testid="itinerary-list-container" [hidden]="loadingMap || noRoute">
  @for (turn of routeData?.Turns ?? []; track turn; let i = $index) {
  <div class="turn-element-outer">
    <div class="turn-element" [attr.data-testid]="'itinerary-turn-' + i" (click)="onTurnClick(turn)" [class.active]="i == itineraryNextTurnIdx">
      <div class="turn-leftside">
        <div class="turn-leftside-element">
          <div class="turn-icon" [class.combined-turn]="turn.CombinedTurn">
            <span class="turn-svg" aria-label="turn"
              [appSvgRecolor]="'assets/icons/default/turn/' + turn.Icon[0]"
              [recolorGradient]="baseGradientStops"></span>
          </div>
          <div class="turn-instruction">
            <div>{{ turn.Instruction[0] }}</div>
          </div>
        </div>
        @if (turn.CombinedTurn) {
        <div class="turn-leftside-element">
          <div class="turn-icon combined-turn">
            <span class="turn-svg" aria-label="turn"
              [appSvgRecolor]="'assets/icons/default/turn/' + turn.Icon[1]"
              [recolorGradient]="baseGradientStops"></span>
          </div>
          <div class="turn-instruction">
            <div>{{ turn.Instruction[1] }}</div>
          </div>
        </div>
        }
      </div>
      @let d = turnDistanceDisplay(turn.DistanceFromStart);
      <div class="distance">
        @if (d.isThousands) {
          {{ d.value | turnValueIntegerThousands }}
        } @else {
          {{ d.value | valueInteger }}
        }
        {{ d.unit.toUpperCase() }}
      </div>
    </div>
  </div>
  }
</div>
}
